// src/reducers/session_reducer.js
import {
  RECEIVE_CURRENT_USER,
  RECEIVE_SESSION_ERRORS,
  RECEIVE_USER_LOGOUT,     // <-- use this
  RECEIVE_USER_SIGN_IN,
} from "../actions/session_actions";

const _nullSession = {
  isAuthenticated: false,
  user: null,
  errors: [],
};

function sessionReducer(state = _nullSession, action) {
  switch (action.type) {
    case RECEIVE_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: true,
        user: action.currentUser,
        errors: [],
      };

    case RECEIVE_USER_SIGN_IN:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        errors: [],
      };

    case RECEIVE_SESSION_ERRORS:
      return {
        ...state,
        errors: action.errors || [],
      };

    case RECEIVE_USER_LOGOUT:   // <-- fix mismatch
      return { ..._nullSession };

    default:
      return state;
  }
}

export default sessionReducer; // named function; no anonymous default export
